import React from 'react';
import styled from 'styled-components';

const Loading = () => {
  return (
    <Style>
      <div className="loader"></div>
    </Style>
  );
};

export default Loading;

const Style = styled.div`
  @font-face {
    font-family: 'SBAggroB';
    src: url('https://fastly.jsdelivr.net/gh/projectnoonnu/noonfonts_2108@1.1/SBAggroB.woff')
      format('woff');
    font-weight: normal;
    font-style: normal;
  }
  @font-face {
    font-family: 'FlightSans-Title';
    src: url('https://fastly.jsdelivr.net/gh/projectnoonnu/2410-1@1.0/FlightSans-Title.woff2') format('woff2');
    font-weight: normal;
    font-style: normal;
}
  .loader {
    width: fit-content;
    font-size: 30px;
    font-family:'FlightSans-Title';
    font-weight: bold;
    text-transform: uppercase;
    color: #0000;
    -webkit-text-stroke: 1px #000;
    background: linear-gradient(90deg, #0000 33%, #000 0 67%, #0000 0) 0/300% 100% no-repeat text;
    animation: l2 2s linear infinite;
  }
  .loader:before {
    content: 'Loading...';
  }
  @keyframes l2 {
    0% {
      background-position: 100%;
    }
  }
`;
